import { Component, Input, Output, EventEmitter } from "@angular/core";
import { CommonModule } from "@angular/common";
import { DialogModule } from "primeng/dialog";
import { ButtonModule } from "primeng/button";

@Component({
  selector: "app-general-modal",
  standalone: true,
  imports: [CommonModule, DialogModule, ButtonModule],
  template: `
    <p-dialog
      [(visible)]="visible"
      [modal]="true"
      [closable]="closable"
      [draggable]="false"
      [resizable]="false"
      [styleClass]="'responsive-general-modal ' + customClass"
      [style]="modalStyle"
      (onHide)="onModalHide()"
    >
      <!-- Header personalizable -->
      <ng-template pTemplate="header" *ngIf="showHeader">
        <ng-content select="[slot=header]"></ng-content>
      </ng-template>

      <!-- Contenido principal -->
      <div [class]="contentClass">
        <ng-content></ng-content>
      </div>

      <!-- Footer personalizable -->
      <ng-template pTemplate="footer" *ngIf="showFooter">
        <ng-content select="[slot=footer]"></ng-content>
      </ng-template>
    </p-dialog>
  `,
  styles: [
    `
      /* Estilos base del dialog */
      :host ::ng-deep .responsive-general-modal .p-dialog-content {
        padding: 0;
        border-radius: 12px;
      }

      :host ::ng-deep .responsive-general-modal .p-dialog {
        border-radius: 12px;
        box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1),
          0 10px 10px -5px rgba(0, 0, 0, 0.04);
      }

      /* Footer personalizable */
      :host ::ng-deep .responsive-general-modal .p-dialog-footer {
        padding: 1rem 1.5rem;
        border-top: 1px solid #e5e7eb;
        border-radius: 0 0 12px 12px;
      }

      /* Overlay mejorado */
      :host ::ng-deep .p-dialog-mask {
        background-color: rgba(0, 0, 0, 0.5);
        backdrop-filter: blur(4px);
        z-index: 1100;
      }

      :host ::ng-deep .responsive-general-modal {
        z-index: 1101;
      }

      /* MOBILE (base) */
      .responsive-general-modal.p-dialog {
        border-bottom-left-radius: 0;
        border-bottom-right-radius: 0;
        border-top-left-radius: 20px;
        border-top-right-radius: 20px;
        margin-bottom: 0;
        width: 100vw !important;
        max-width: 100vw !important;
        animation: slideUp 0.3s ease-out;
        /* Colocación tipo bottom sheet */
        position: fixed;
        left: 50%;
        transform: translateX(-50%);
        bottom: 0;
      }

      .responsive-general-modal-mask.p-dialog-mask {
        background-color: rgba(
          0,
          0,
          0,
          0.6
        ) !important; /* overlay más oscuro en mobile */
      }

      /* DESKTOP */
      @media (min-width: 768px) {
        .responsive-general-modal.p-dialog {
          /* Centrado clásico */
          position: fixed;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          animation: fadeInScale 0.3s ease-out;
          border-radius: 12px;
          width: auto !important;
          max-width: 90vw !important;
        }
      }

      /* Animaciones */
      @keyframes fadeInScale {
        from {
          opacity: 0;
          transform: translate(-50%, -50%) scale(0.9);
        }
        to {
          opacity: 1;
          transform: translate(-50%, -50%) scale(1);
        }
      }

      @keyframes slideUp {
        from {
          transform: translateY(100%);
          opacity: 0;
        }
        to {
          transform: translateY(0);
          opacity: 1;
        }
      }
    `,
  ],
})
export class GeneralModalComponent {
  @Input() visible: boolean = false;
  @Input() showHeader: boolean = false;
  @Input() showFooter: boolean = false;
  @Input() closable: boolean = false;
  @Input() customClass: string = "";
  @Input() contentClass: string = "p-6";
  @Input() modalStyle: any = { width: "90vw", maxWidth: "400px" };

  @Output() visibleChange = new EventEmitter<boolean>();
  @Output() modalHide = new EventEmitter<void>();

  onModalHide() {
    this.visible = false;
    this.visibleChange.emit(false);
    this.modalHide.emit();
  }
}
